import { render, staticRenderFns } from "./UserGoalsBadges.vue?vue&type=template&id=3addb078&"
import script from "./UserGoalsBadges.vue?vue&type=script&lang=js&"
export * from "./UserGoalsBadges.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports